// extracted by mini-css-extract-plugin
export var item = "PageResultsList-module--item--bd65d";
export var list = "PageResultsList-module--list--c257b";
export var moreButtonContainer = "PageResultsList-module--more-button-container--6d6ca";